import * as React from 'react';

import { ExperienceTrackerContext } from '@atlassian/experience-tracker';

export type ExperienceTrackerAPI = React.ContextType<typeof ExperienceTrackerContext>;

export const useExperienceTracker = (): ExperienceTrackerAPI => React.useContext(ExperienceTrackerContext);
